import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const CustomTooltip = ({ title, ...ttProps }) => {
  return (
    <Tooltip title={title} {...ttProps}>
      <QuestionCircleOutlined style={{ color: '#8c8c8c', marginLeft: 5 }} />
    </Tooltip>
  );
};

export default CustomTooltip;
